<template>
  <div class="art">
    <picture>
      <source
        media="(max-width: 767px)"
        srcset="~@/assets/images/art-mobile.png 767w"
      />
      <img class="art-banner" src="~@/assets/images/art.jpg" />
    </picture>
    <Title />
    <ArtPage1 v-if="page === '1'" />
    <ArtPage2 v-if="page === '2'" />
    <ArtPage3 v-if="page === '3'" />
  </div>
</template>

<script>
import Title from 'Pages/MainModule/Title.vue';
import ArtPage1 from 'Pages/ArtModule/ArtPage1.vue';
import ArtPage2 from 'Pages/ArtModule/ArtPage2.vue';
import ArtPage3 from 'Pages/ArtModule/ArtPage3.vue';
export default {
  name: 'Art',
  data() {
    return {
      page: this.$route.query.page,
    };
  },
  components: {
    Title,
    ArtPage1,
    ArtPage2,
    ArtPage3,
  },
  watch: {
    $route() {
      this.page = this.$route.query.page;
    },
  },
};
</script>

<style scoped>
.art {
  text-align: left;
}
.art-banner {
  width: 100%;
  vertical-align: top;
}
.art > div {
  margin: 20px 20% 0 20%;
}
@media (max-width: 767px) {
  .art > div {
    margin: 0 20px;
  }
  .art-banner {
    margin-top: 10px;
  }
}
@media (min-width: 768px) and (max-width: 1024px) {
  .art > div {
    margin: 20px 10% 0 10%;
  }
}
</style>
